var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBond(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8 L52 18 V22 H12 V18 Z",
    fill: "#C9A227"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 6,
    height: 22,
    fill: "#1A2A52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    width: 6,
    height: 22,
    fill: "#1A2A52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 6,
    height: 22,
    fill: "#1A2A52"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 0,
    height: 22,
    fill: "#1A2A52"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 6,
    height: 22,
    fill: "#1A2A52"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 44,
    width: 44,
    height: 6,
    fill: "#4A5A82"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 50,
    width: 48,
    height: 5,
    rx: 2,
    fill: "#C9A227"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 3,
    fill: "#1A2A52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBond);
export default __webpack_public_path__ + "static/media/bond.ce6fe861024cdeca1775df9943e0a83c.svg";
export { ForwardRef as ReactComponent };